import templateUrl from './editShiftTemplate.html';

export default {
  controllerProvider: async () =>
    (await import(/* webpackChunkName: "settings" */ './editShiftTemplateComponentCtrl')).default,
  controllerAs: 'ctrl',
  bindings: {
    shiftTemplate: '=',
    onSubmit: '&',
    dismiss: '&',
  },
  templateUrl,
};
